import { OrdersTable } from '@/components/features/orders/OrdersTable'

export const Orders = () => {
  return <OrdersTable />
}
